// composable: useUserApi.ts
import { inject, InjectionKey } from 'vue';
import { DutyApiService } from './dutyApiService';

export const DUTY_API_KEY: InjectionKey<DutyApiService> = Symbol('DutyApiService');

export function useDutyApi(): DutyApiService {
	const service = inject<DutyApiService>(DUTY_API_KEY);
	if (!service) throw new Error('DutyApiService not provided');
	return service;
}
